<template>
  <div class="home">
    <page-wrapper :loading="loadingAides" :error="apiError">
      <div class="head">
        <div class="head-row left-row">
          <div class="statut">
            <h2>Mon projet de rénovation</h2>
            <p>Mon client est <strong>{{ beneficiaires[entryDatas.statutBeneficiaire] }}</strong></p>
          </div>
          <div class="city">
            {{ city }}
          </div>
          <div v-if="dateConstruction" class="construction-date">
            <p>Logement construit</p>
            <strong>{{ dateConstruction }}</strong>
          </div>
        </div>
        <div class="head-row right-row">
          <div class="list-postes">
            <div v-for="poste in firstPostesTravaux" :key="poste" class="poste">
              {{ getPosteByName(poste).label }}
            </div>
          </div>
        </div>
        <button
          v-if="showMorePosteTravaux"
          class="button plus-button"
          :class="{ activ: showAllPostes }"
          @click="toggleListPostes">
          <img src="../assets/pictos/top-arrow.svg"> <span>voir {{ showAllPostes ? 'moins' : 'plus' }}</span>
        </button>
      </div>
      <transition-height>
        <div v-show="showAllPostes" class="last-postes">
          <div class="list-postes">
            <div v-for="poste in lastPostesTravaux" :key="poste" class="poste">
              {{ getPosteByName(poste).label }}
            </div>
          </div>
        </div>
      </transition-height>
      <div class="aides-wrapper">
        <liste-aides :aides="aides" @click-aide="goToAide"></liste-aides>
      </div>
    </page-wrapper>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ListeAides from '../components/aides/ListeAides'
import beneficiaires from '../datas/beneficiaires'
import TransitionHeight from '../components/TransitionHeight'
import PageWrapper from '../components/PageWrapper'

export default {
  name: 'Home',
  components: {
    ListeAides,
    TransitionHeight,
    PageWrapper
  },
  created () {
    this.$store.dispatch('initEntryParams')
    this.$store.dispatch('getAides')
  },
  data () {
    return {
      beneficiaires: beneficiaires,
      showAllPostes: false,
      maxPostesDisplay: 3
    }
  },
  computed: {
    ...mapState(['entryDatas', 'apiError', 'travaux', 'loadingAides', 'aides', 'city']),
    dateConstruction () {
      return this.entryDatas.dateConstruction
    },
    firstPostesTravaux () {
      return this.entryDatas.travaux.slice(0, this.maxPostesDisplay)
    },
    lastPostesTravaux () {
      return this.entryDatas.travaux.slice(this.maxPostesDisplay - 1)
    },
    showMorePosteTravaux () {
      return this.entryDatas.travaux.length > 3
    }
  },
  methods: {
    getPosteByName (name) {
      return this.travaux[name]
    },
    toggleListPostes () {
      this.showAllPostes = !this.showAllPostes
    },
    goToAide (idAide) {
      this.$router.push('/detail-aide/' + idAide)
    }
  }
}
</script>

<style lang="scss">
.home {
  .head {
    margin-top: $v-spacer-xl;
    padding: $v-spacer-md $h-spacer-lg;
    border-radius: $radius $radius 0 0;
    background-color: $primary-color;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    min-height: 120px;
    text-align: left;
    position: relative;
    .head-row {
      display: flex;
      align-items: center;
    }
    .statut {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      margin-right: $h-spacer-xl;
      h2 {
        margin: 0;
      }
      p {
        font-family: $secondary-font;
        font-size: $text-size;
      }
    }
    .city {
      font-weight: 700;
      font-size: $text-size-md;
      padding-left: 30px;
      background-image: url('../assets/pictos/location-pin.svg');
      background-repeat: no-repeat;
      background-position: left center;
      background-size: 20px;
      height: 40px;
      display: flex;
      align-items: center;
      margin-right: 80px;
    }
    .construction-date {
      font-size: $text-size-md;
      padding-left: 40px;
      background-image: url('../assets/pictos/calendar.svg');
      background-repeat: no-repeat;
      background-position: left center;
      background-size: 28px;
      height: 40px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-right: $h-spacer-xl;
    }
    .plus-button {
      font-family: $secondary-font;
      position: absolute;
      margin: 0 auto;
      background-image: $primary-gradient;
      color: #fff;
      font-size: $text-size;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%) translateY(50%);
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 10px;
      border-radius: $radius-sm;
      height: 32px;
      z-index: 5;
      img {
        transform-origin: center center;
        transition: .3s transform;
        transform: rotateX(180deg);
      }
      span {
        margin-left: 10px;
      }
      &.activ {
        img {
          transform: rotateX(0deg);
        }
      }
    }
  }
  .last-postes {
    border-top: 1px solid $secondary-color;
    background-color: $primary-color;
    color: #fff;
    .list-postes {
      display: flex;
      padding: 20px;
      flex-wrap: wrap;
      .poste {
        flex: 0 1 27%;
        display: flex;
        align-items: center;
      }
    }
  }
  .list-postes {
    text-align: left;
    font-family: $secondary-font;
    font-size: $text-size;
    .poste {
      padding-left: 40px;
      background-image: url('../assets/pictos/check.svg');
      background-size: 20px 15px;
      background-repeat: no-repeat;
      background-position: left center;
      margin: 10px 0;
      font-size: $text-size-md;
    }
  }
  .aides-wrapper {
    padding-top: $v-spacer-md;
  }
}
@media (max-width:1020px) {
  .home {
    .head {
      flex-direction: column;
      align-items: stretch;
      justify-content: center;
      .head-row {
        &.right-row {
          margin-top: $v-spacer;
          display: block;
        }
      }
      .construction-date {
        margin-right: 0;
      }
      .list-postes {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        .poste {
          flex: 0 1 27%;
        }
      }
    }
  }
}
</style>
